import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";

import { BookmarkViewModel, CategoryWithCountsViewModel } from "../apiClient";

import { AppLayout } from "../components/appLayout";
import useApiClient from "../hooks/useApiClient";
import { BookmarkAddEditForm } from "../components/forms/bookmarkAddEditForm";

export const BookmarkEdit = () => {
    const routeParams = useParams();
    const apiClient = useApiClient();
    const navigate = useNavigate();
    const [categories, setCategories] = useState<CategoryWithCountsViewModel[]>([]);
    const [bookmark, setBookmark] = useState<BookmarkViewModel | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!apiClient) return;

        const loadData = async () => {
            const categoriesPromise = apiClient.categoriesAll().then(categories => setCategories(categories));
            const bookmarkPromise = apiClient.bookmarksGET2(routeParams.id!).then(bookmark => setBookmark(bookmark));
            await Promise.all([categoriesPromise, bookmarkPromise]);
            setLoading(false);
        };

        loadData();
    }, [apiClient, setCategories, setBookmark, routeParams]);

    return (
        <AppLayout loading={loading}>
            <Container className="py-2">
                <Breadcrumb>
                    <LinkContainer to={`/bookmarks`}>
                        <Breadcrumb.Item>Bookmarks</Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>Edit bookmark</Breadcrumb.Item>
                </Breadcrumb>

                <div className="mb-3">
                    <h1 className="mb-1">Edit bookmark: {bookmark?.name ?? bookmark?.url}</h1>
                </div>

                <Card>
                    <Card.Body className="p-4">
                        <BookmarkAddEditForm
                            apiClient={apiClient!}
                            bookmark={bookmark!}
                            categories={categories}
                            onSave={() => navigate(`/bookmarks`)}
                        />
                    </Card.Body>
                </Card>
            </Container>
        </AppLayout>
    );
};